export interface QuestionReasonData {
  questionReasonId: number;
  reason: string;
  description: string;
  sisplayedNegative: boolean;
  displayedPositive: boolean;
  isActive: boolean;
}
